/* import __COLOCATED_TEMPLATE__ from './body.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
@classNames('card-body')
export default class SharedCardBody extends Component {}
